export default {

    methods: {

        /**
         * @param name
         * @return {*}
         */
        addCCToRoute(name) {
            if (this.isCCExists()) {
                const prefix = this.getParamPrefix(name);
                const cc = this.getCC();
                return `${name}${prefix}cc=${cc}`;
            }

            return name;
        },

        /*
        * @return {boolean}
        */
        isCCExists() {
            const ccVal = this.getCC();
            return (ccVal && ccVal.length > 0);
        },

        /**
         * @return {string | null}
         */
        getCC() {
            const url = new URL(window.location.href);
            return url.searchParams.get('cc');
        },

        /**
         * @param {string} name
         * @return {string}
         */
        getParamPrefix(name) {
            return name.includes('?') ? '&' : '?';
        },

        /**
         *
         * @param {string} name
         * @param {string} parameters
         * @return {string}
         */
        routeParsed( name, parameters ) {
            const prefix = this.getParamPrefix(name);
            const fullParameters =  parameters ? `${prefix}${parameters}` : '';
            return `${name}${fullParameters}`;
        }
    }
}